module.exports = __webpack_public_path__ + "img/horizontal_7_1_6000.c4edc34c.png";